<template>
  <div class="selector-area">
    <sa-editor
      :class="context.classes.selector"
      class="form-editor"
      ref="editor"
      :name="context.node.name"
      :content="context._value"
      :disabled="context.disabled === true"
      text-bubble-menu
      paragraph-as-div
      emoji
      @blur="handleBlur"
    />
  </div>
</template>

<script setup lang="ts">
import SaEditor, { ISaEditor } from "src/features/tip-tap-editor/SaEditor.vue";
import { isNullOrUndefined } from "src/shared/object-utils";
import { ref, PropType } from "vue";
import { FormKitFrameworkContext } from "@formkit/core";
import { useEmitterOn } from "src/composables/useEmitterOn";

const props = defineProps({
  context: {
    type: Object as PropType<FormKitFrameworkContext>,
    required: true,
  },
  autofocus: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const editor = ref<ISaEditor>();

const getHTML = () => {
  if (isNullOrUndefined(editor)) {
    throw new Error("Editor not defined");
  }

  return editor.value?.getHTML();
};

const handleBlur = async () => {
  await props.context.node.input(getHTML());
  props.context.handlers.blur();
};

useEmitterOn("insert-editor-placeholder", placeholder => {
  if (isNullOrUndefined(editor)) {
    throw new Error("Editor not defined");
  }

  editor.value?.insertContent(placeholder);
});
</script>

<style scoped>
.selector-area {
  padding: var(--formkit-input-padding);
  height: 100%;
}
.formkit-selector {
  appearance: none;
  border: 0;
  background-color: transparent;
}

.formkit-selector:focus {
  outline: none;
}
</style>
